import React, { useEffect, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const QRCodeScanner = () => {
    const [scanResult, setScanResult] = useState(null);

    useEffect(() => {
        // Initialize the QR code scanner
        const scanner = new Html5QrcodeScanner('reader', {
            qrbox: {
                width: 250,
                height: 250,
            },
            fps: 5, // Frames per second
        });

        // Render the scanner
        scanner.render(
            (result) => {
               alert('ok')
                setScanResult(result);
                scanner.clear(); // Stop scanning after a result is found
            },
            (error) => {
                // Error callback
                //console.error('QR Code Scan Error:', error);
            }
        );

        // Cleanup function to stop the scanner when the component unmounts
        return () => {
            scanner.clear();
        };
    }, []);

    return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
            <h1>QR Code Scanner</h1>
            <div id="reader" style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}></div>
            <h2>Scanned Result:</h2>
            <p>{scanResult || 'No result yet'}</p>
        </div>
    );
};

export default QRCodeScanner;